import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const dataTypes = ['texto', 'imagen', 'audio', 'video', 'documento'];

const GramaticaForm = ({ gramatica, type, guardaGramatica, nodos, archivos, functionesChatbot }) => {
	const [editableGramatica, setEditableGramatica] = useState(gramatica.arista);
	const [title, setTitle] = useState(gramatica.nombre);
	const [flagFunctions, setFlagFunctions] = useState(false);

	useEffect(() => {
		if (type === 'fuerte' && !title) {
			setEditableGramatica({ ...editableGramatica, nodoDestino: 0 });
		} else if (type === 'debil' && !title) {
			const temp = editableGramatica;
			delete temp.nodoDestino;
			setEditableGramatica(temp);
		}
	}, [title, type]);

	useEffect(() => {
		if (editableGramatica.ejecutaFuncion && editableGramatica.ejecutaFuncion.length) {
			const temp = { ...editableGramatica };
			let flag = false;
			temp.ejecutaFuncion = temp.ejecutaFuncion.map((funcion) => {
				if (functionesChatbot.includes(funcion.nombreFuncion)) {
					return funcion;
				} else {
					funcion.nombreFuncion = '';
					flag = true;
					return funcion;
				}
			});
			setFlagFunctions(flag);
			setEditableGramatica(temp);
		}
	}, [functionesChatbot]);

	return (
		<div style={{ width: '80%', margin: '40px auto' }}>
			<Title title={title} setTitle={setTitle} />
			<div className='form-container'>
				{type === 'fuerte' && <DestSelection editableGramatica={editableGramatica} setEditableGramatica={setEditableGramatica} nodos={nodos} />}
				<Scripts editableGramatica={editableGramatica} setEditableGramatica={setEditableGramatica} archivos={archivos} />
				<Buttons editableGramatica={editableGramatica} setEditableGramatica={setEditableGramatica} />
				<Conditions editableGramatica={editableGramatica} setEditableGramatica={setEditableGramatica} />
				<Functions editableGramatica={editableGramatica} setEditableGramatica={setEditableGramatica} functionesChatbot={functionesChatbot} />
				<SaveDelete
					editableGramatica={editableGramatica}
					gramatica={gramatica}
					title={title}
					guardaGramatica={guardaGramatica}
					flagFunctions={flagFunctions}
				/>
			</div>
		</div>
	);
};

export default GramaticaForm;

function toggle_variable(parametro) {
	if (parametro[0] === '&') {
		parametro = parametro.slice(1, -1);
	} else {
		parametro = '&' + parametro + '*';
	}
	return parametro;
}

//#region Seccion de titulo, para almacenamiento de la gramatica

function Title({ title, setTitle }) {
	return (
		<div align='right'>
			<div className='taby'>
				<input onChange={(e) => setTitle(e.target.value)} value={title} />
			</div>
		</div>
	);
}

//#endregion

//#region Seccion para la seleccion del nodo de destino
function DestSelection({ editableGramatica, setEditableGramatica, nodos }) {
	return (
		<div>
			<b style={{ marginRight: 10 }}>Al nodo: </b>
			<select onChange={(e) => setEditableGramatica({ ...editableGramatica, nodoDestino: Number(e.target.value) })} value={editableGramatica.nodoDestino}>
				<option key='default' value={0}>
					Selecciona un Nodo...
				</option>
				{nodos.map((nodo) => (
					<option key={nodo.nodo} value={nodo.nodo}>
						Nodo {nodo.nodo} ({nodo.nombre})
					</option>
				))}
			</select>
		</div>
	);
}
//#endregion

//#region Seccion de los scripts

function Scripts({ editableGramatica, setEditableGramatica, archivos }) {
	return (
		<div>
			{editableGramatica.scripts &&
				editableGramatica.scripts.map((script, index) => {
					// script => {tipo:XXXX, valor:XXXX, externo:XXXX}
					switch (script.tipo) {
						case 'imagen':
							return (
								<MultimediaScript
									key={index}
									index={index}
									editableGramatica={editableGramatica}
									setEditableGramatica={setEditableGramatica}
									archivos={archivos.imagenes}
								/>
							);
						case 'audio':
							return (
								<MultimediaScript
									key={index}
									index={index}
									editableGramatica={editableGramatica}
									setEditableGramatica={setEditableGramatica}
									archivos={archivos.audios}
								/>
							);
						case 'video':
							return (
								<MultimediaScript
									key={index}
									index={index}
									editableGramatica={editableGramatica}
									setEditableGramatica={setEditableGramatica}
									archivos={archivos.videos}
								/>
							);
						case 'documento':
							return (
								<MultimediaScript
									key={index}
									index={index}
									editableGramatica={editableGramatica}
									setEditableGramatica={setEditableGramatica}
									archivos={archivos.documentos}
								/>
							);
						default:
							return <TextScript key={index} index={index} editableGramatica={editableGramatica} setEditableGramatica={setEditableGramatica} />;
					}
				})}
			<button
				className='add-button rectangle'
				onClick={() =>
					setEditableGramatica({
						...editableGramatica,
						scripts: [...editableGramatica.scripts, { tipo: 'texto', valor: '', externo: false }],
					})
				}
			>
				+
			</button>
		</div>
	);
}

function TextScript({ index, editableGramatica, setEditableGramatica }) {
	return (
		<div>
			<hr />
			<b>Script {index + 1}</b>
			<br />
			<div>
				<textarea
					onChange={(e) => {
						const newScripts = editableGramatica.scripts;
						newScripts[index] = { tipo: 'texto', valor: e.target.value, externo: false };
						setEditableGramatica({
							...editableGramatica,
							scripts: newScripts,
						});
					}}
					value={editableGramatica.scripts[index].valor}
					style={{ width: '60%', height: 64, resize: 'none' }}
				></textarea>

				<button
					onClick={() =>
						setEditableGramatica({
							...editableGramatica,
							scripts: [...editableGramatica.scripts.slice(0, index), ...editableGramatica.scripts.slice(index + 1)],
						})
					}
					className='remove-button'
					style={{ position: 'absolute' }}
				>
					x
				</button>
			</div>

			<div style={{ marginTop: '10px' }}>
				<span style={{ marginRight: '5px' }}>Tipo de script</span>
				<select
					onChange={(e) => {
						const newScripts = editableGramatica.scripts;
						newScripts[index] = { tipo: e.target.value, valor: '', externo: false };
						setEditableGramatica({
							...editableGramatica,
							scripts: newScripts,
						});
					}}
					value={editableGramatica.scripts[index].tipo}
				>
					{dataTypes.map((type) => (
						<option key={type} value={type}>
							{type}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}

function MultimediaScript({ index, editableGramatica, setEditableGramatica, archivos }) {
	return (
		<div>
			<hr />
			<b>Script {index + 1}</b>
			<br />
			<div style={{ marginTop: '10px' }}>
				{!editableGramatica.scripts[index].externo ? (
					<select
						onChange={(e) => {
							const newScripts = editableGramatica.scripts;
							newScripts[index].valor = e.target.value;
							setEditableGramatica({
								...editableGramatica,
								scripts: newScripts,
							});
						}}
						value={editableGramatica.scripts[index].valor}
					>
						<option key='' value=''>
							Selecciona un archivo
						</option>
						{archivos.map((file) => (
							<option key={file} value={file}>
								{file}
							</option>
						))}
					</select>
				) : (
					<span>
						<span style={{ marginRight: '15px' }}>URL del archivo:</span>
						<input
							style={{ width: '500px' }}
							value={editableGramatica.scripts[index].valor}
							onChange={(e) => {
								const newScripts = editableGramatica.scripts;
								newScripts[index].valor = e.target.value;
								setEditableGramatica({
									...editableGramatica,
									scripts: newScripts,
								});
							}}
						/>
					</span>
				)}

				<button
					onClick={() =>
						setEditableGramatica({
							...editableGramatica,
							scripts: [...editableGramatica.scripts.slice(0, index), ...editableGramatica.scripts.slice(index + 1)],
						})
					}
					className='remove-button'
					style={{ position: 'absolute' }}
				>
					x
				</button>
			</div>
			<div style={{ marginTop: '10px' }}>
				<span>¿El archivo es externo?</span>
				<input
					type='checkbox'
					checked={editableGramatica.scripts[index].externo}
					onChange={() => {
						const newScripts = editableGramatica.scripts;
						newScripts[index].externo = !newScripts[index].externo;
						newScripts[index].valor = '';
						setEditableGramatica({
							...editableGramatica,
							scripts: newScripts,
						});
					}}
				/>
			</div>
			<div style={{ marginTop: '10px' }}>
				<span style={{ marginRight: '5px' }}>Tipo de script</span>
				<select
					onChange={(e) => {
						const newScripts = editableGramatica.scripts;
						newScripts[index] = { tipo: e.target.value, valor: '', externo: false };
						setEditableGramatica({
							...editableGramatica,
							scripts: newScripts,
						});
					}}
					value={editableGramatica.scripts[index].tipo}
				>
					{dataTypes.map((type) => (
						<option key={type} value={type}>
							{type}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}

//#endregion

//#region Seccion para la creacion de botones
function Buttons({ editableGramatica, setEditableGramatica }) {
	return (
		<div>
			<br />
			<hr />
			<div>
				<b>Botones</b>
			</div>
			<div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
				{editableGramatica.botones &&
					editableGramatica.botones.map((boton, index) => {
						return (
							<div key={index} style={{ margin: 10 }}>
								<small>Opcion {index + 1}</small>
								<button
									onClick={() =>
										setEditableGramatica({
											...editableGramatica,
											botones: [...editableGramatica.botones.slice(0, index), ...editableGramatica.botones.slice(index + 1)],
										})
									}
									className='remove-button'
								>
									x
								</button>
								<br />
								<input
									onChange={(e) =>
										setEditableGramatica({
											...editableGramatica,
											botones: [...editableGramatica.botones.slice(0, index), e.target.value, ...editableGramatica.botones.slice(index + 1)],
										})
									}
									value={editableGramatica.botones[index]}
								></input>
							</div>
						);
					})}
				<button
					onClick={() =>
						editableGramatica.botones
							? setEditableGramatica({ ...editableGramatica, botones: [...editableGramatica.botones, ''] })
							: setEditableGramatica({ ...editableGramatica, botones: [''] })
					}
					className='add-button'
					style={{ width: 80, height: 80, marginTop: 10 }}
				>
					+
				</button>
			</div>
		</div>
	);
}
//#endregion

//#region Seccion para la creacion y eliminacion de condiciones

function Conditions({ editableGramatica, setEditableGramatica }) {
	const condicionesDefaultObj = {
		intent: { esIntent: true, nombreIE: 'intent', condicional: '', valor: '' },
		entity: { esIntent: false, nombreIE: '', condicional: '', valor: '' },
		variable: { variable: '', condicional: '', valor: '' },
	};

	const [creandoCondicion, setCreandoCondicion] = useState(false);

	return (
		<div>
			<br />
			<hr />
			<div>
				<b style={{ marginRight: 20 }}>Condiciones</b>
				{editableGramatica.condiciones && editableGramatica.condiciones.length > 1 && (
					<div style={{ display: 'inline' }}>
						<small>Relación: </small>
						<input
							placeholder='Ej: * AND *'
							onChange={(e) => setEditableGramatica({ ...editableGramatica, operacion: e.target.value })}
							value={editableGramatica.operacion}
						/>
					</div>
				)}
			</div>
			<div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
				{editableGramatica.condiciones &&
					editableGramatica.condiciones.map((condicion, index) => {
						return (
							<div key={index} style={{ margin: 10 }}>
								<button
									onClick={() =>
										setEditableGramatica({
											...editableGramatica,
											condiciones: [...editableGramatica.condiciones.slice(0, index), ...editableGramatica.condiciones.slice(index + 1)],
											operacion: editableGramatica.condiciones.length <= 2 ? '' : editableGramatica.operacion,
										})
									}
									className='remove-button'
									style={{ marginLeft: '65px' }}
								>
									x
								</button>
								<br />
								{condicion.variable !== undefined && (
									<>
										<small>Variable</small>
										<br />
										<input
											onChange={(e) =>
												setEditableGramatica({
													...editableGramatica,
													condiciones: [
														...editableGramatica.condiciones.slice(0, index),
														{ ...editableGramatica.condiciones[index], variable: e.target.value },
														...editableGramatica.condiciones.slice(index + 1),
													],
												})
											}
											value={editableGramatica.condiciones[index].variable}
										></input>
										<br />
									</>
								)}
								{condicion.esIntent === false && (
									<>
										<small>Nombre Entity</small>
										<br />
										<input
											onChange={(e) =>
												setEditableGramatica({
													...editableGramatica,
													condiciones: [
														...editableGramatica.condiciones.slice(0, index),
														{ ...editableGramatica.condiciones[index], nombreIE: e.target.value },
														...editableGramatica.condiciones.slice(index + 1),
													],
												})
											}
											value={editableGramatica.condiciones[index].nombreIE}
										></input>
										<br />
									</>
								)}
								<small>Condicional</small>
								<br />
								<select
									onChange={(e) =>
										setEditableGramatica({
											...editableGramatica,
											condiciones: [
												...editableGramatica.condiciones.slice(0, index),
												{ ...editableGramatica.condiciones[index], condicional: e.target.value },
												...editableGramatica.condiciones.slice(index + 1),
											],
										})
									}
									value={editableGramatica.condiciones[index].condicional}
								>
									<option key='default' value=''>
										Selecciona una condición
									</option>
									<option key='==' value='=='>
										Igual a
									</option>
									<option key='!=' value='!='>
										Diferente a
									</option>
									<option key='<' value='<'>
										Menor a
									</option>
									<option key='<=' value='<='>
										Menor o igual a
									</option>
									<option key='>' value='>'>
										Mayor a
									</option>
									<option key='>=' value='>='>
										Mayor o igual a
									</option>
								</select>
								<br />
								<small>
									Valor <b>{condicion.variable !== undefined ? 'Variable' : condicion.esIntent ? 'Intent' : 'Entity'}</b>
								</small>
								<br />
								<input
									onChange={(e) =>
										setEditableGramatica({
											...editableGramatica,
											condiciones: [
												...editableGramatica.condiciones.slice(0, index),
												{ ...editableGramatica.condiciones[index], valor: e.target.value },
												...editableGramatica.condiciones.slice(index + 1),
											],
										})
									}
									value={editableGramatica.condiciones[index].valor}
								></input>
								<br />
							</div>
						);
					})}
				{creandoCondicion ? (
					<div>
						<button onClick={() => addCondicion(condicionesDefaultObj.intent)} className='toggle-button'>
							Intent
						</button>
						<br />
						<button onClick={() => addCondicion(condicionesDefaultObj.entity)} className='toggle-button'>
							Entity
						</button>
						<br />
						<button onClick={() => addCondicion(condicionesDefaultObj.variable)} className='toggle-button'>
							Variable
						</button>
					</div>
				) : (
					<button onClick={() => setCreandoCondicion(true)} className='add-button square'>
						+
					</button>
				)}
			</div>
		</div>
	);

	function addCondicion(nuevaCond) {
		if (editableGramatica.condiciones) {
			setEditableGramatica({ ...editableGramatica, condiciones: [...editableGramatica.condiciones, nuevaCond] });
		} else {
			setEditableGramatica({ ...editableGramatica, condiciones: [nuevaCond] });
		}
		setCreandoCondicion(false);
	}
}

//#endregion

//#region Seccion para la asignacion de funciones

function Functions({ editableGramatica, setEditableGramatica, functionesChatbot }) {
	const funcionDefault = { nombreFuncion: '', guardarEn: '', parametros: [] };

	return (
		<div>
			<br />
			<hr />

			{!editableGramatica.ejecutaFuncion && (
				<div>
					<b>Funciones que Ejecuta </b>
				</div>
			)}
			<div>
				{editableGramatica.ejecutaFuncion &&
					editableGramatica.ejecutaFuncion.map((funcion, index) => {
						return (
							<div key={index} style={{ margin: 10, textAlign: 'center' }}>
								<hr style={{ borderWidth: '2px' }} />
								<h2>Función número {index + 1}</h2>
								<h3>- {funcion.nombreFuncion} -</h3>
								<button
									onClick={() => {
										const temp = { ...editableGramatica };

										if (temp.ejecutaFuncion.length === 1) {
											delete temp.ejecutaFuncion;
										} else {
											temp.ejecutaFuncion = [...temp.ejecutaFuncion.slice(0, index), ...temp.ejecutaFuncion.slice(index + 1)];
										}

										setEditableGramatica(temp);
									}}
									className='remove-button'
									style={{ marginLeft: '0px' }}
								>
									x
								</button>
								<br />
								<small>Nombre de la función</small>
								<br />
								{/* <input
									onChange={(e) =>
										setEditableGramatica({
											...editableGramatica,
											ejecutaFuncion: [
												...editableGramatica.ejecutaFuncion.slice(0, index),
												{ ...editableGramatica.ejecutaFuncion[index], nombreFuncion: e.target.value },
												...editableGramatica.ejecutaFuncion.slice(index + 1),
											],
										})
									}
									value={editableGramatica.ejecutaFuncion[index].nombreFuncion}></input> */}
								<select
									onChange={(e) =>
										setEditableGramatica({
											...editableGramatica,
											ejecutaFuncion: [
												...editableGramatica.ejecutaFuncion.slice(0, index),
												{ ...editableGramatica.ejecutaFuncion[index], nombreFuncion: e.target.value },
												...editableGramatica.ejecutaFuncion.slice(index + 1),
											],
										})
									}
									value={editableGramatica.ejecutaFuncion[index].nombreFuncion}
								>
									<option key='' value=''>
										Selecciona un archivo
									</option>
									{functionesChatbot.map((funcion) => (
										<option key={funcion} value={funcion}>
											{funcion}
										</option>
									))}
								</select>
								<br />
								<small>Parámetros</small>
								<br />
								{funcion.parametros &&
									funcion.parametros.map((parametro, index2) => {
										return (
											<div key={index2}>
												<input
													onChange={(e) =>
														setEditableGramatica({
															...editableGramatica,
															ejecutaFuncion: [
																...editableGramatica.ejecutaFuncion.slice(0, index),
																{
																	...editableGramatica.ejecutaFuncion[index],
																	parametros: [
																		...editableGramatica.ejecutaFuncion[index].parametros.slice(0, index2),
																		e.target.value,
																		...editableGramatica.ejecutaFuncion[index].parametros.slice(index2 + 1),
																	],
																},
																...editableGramatica.ejecutaFuncion.slice(index + 1),
															],
														})
													}
													value={editableGramatica.ejecutaFuncion[index].parametros[index2]}
												/>

												<button
													onClick={() =>
														setEditableGramatica({
															...editableGramatica,
															ejecutaFuncion: [
																...editableGramatica.ejecutaFuncion.slice(0, index),
																{
																	...editableGramatica.ejecutaFuncion[index],
																	parametros: [
																		...editableGramatica.ejecutaFuncion[index].parametros.slice(0, index2),
																		toggle_variable(editableGramatica.ejecutaFuncion[index].parametros[index2]),
																		...editableGramatica.ejecutaFuncion[index].parametros.slice(index2 + 1),
																	],
																},
																...editableGramatica.ejecutaFuncion.slice(index + 1),
															],
														})
													}
													className='toggle-button'
													style={{ wordWrap: 'unset' }}
												>
													{parametro[0] === '&' ? 'Convertir a constante' : 'Convertir a variable'}
												</button>

												<button
													onClick={() => {
														const aristaTemp = { ...editableGramatica };
														const funcion = aristaTemp.ejecutaFuncion[index];

														funcion.parametros = [...funcion.parametros.slice(0, index2), ...funcion.parametros.slice(index2 + 1)];

														aristaTemp.ejecutaFuncion[index] = funcion;

														setEditableGramatica(aristaTemp);
													}}
													className='remove-button'
													style={{ marginLeft: '5px' }}
												>
													x
												</button>
											</div>
										);
									})}
								<button
									onClick={() =>
										setEditableGramatica({
											...editableGramatica,
											ejecutaFuncion: [
												...editableGramatica.ejecutaFuncion.slice(0, index),
												{
													...editableGramatica.ejecutaFuncion[index],
													parametros: editableGramatica.ejecutaFuncion[index].parametros
														? [...editableGramatica.ejecutaFuncion[index].parametros, '']
														: [''],
												},
												...editableGramatica.ejecutaFuncion.slice(index + 1),
											],
										})
									}
									className='add-button rectangle'
								>
									+
								</button>
							</div>
						);
					})}
				<button
					onClick={() =>
						editableGramatica.ejecutaFuncion
							? setEditableGramatica({
									...editableGramatica,
									ejecutaFuncion: [...editableGramatica.ejecutaFuncion, funcionDefault],
							  })
							: setEditableGramatica({ ...editableGramatica, ejecutaFuncion: [funcionDefault] })
					}
					className='add-button square'
				>
					+
				</button>
			</div>
		</div>
	);
}

//#endregion

//#region Seccion de los botones para guardado

function SaveDelete({ editableGramatica, gramatica, title, guardaGramatica, flagFunctions }) {
	const history = useHistory();

	// Las validaciones deben de regresar true cuando algo no esta validado

	// Se valida que se haya especificado un titulo a la gramatica
	const titleValidation = title ? false : true;

	// Se valida que se haya escogido un nodo de destino
	const nodoDestinoValidation = editableGramatica.nodoDestino === 0;

	// Se valida que se haya definido al menos un script de mensaje
	const scriptValidation = editableGramatica.scripts.length === 0;

	// Se valida que se hayan definido los scripts correctamente
	const scriptEmptyValidation = !editableGramatica.scripts.every((script) => script.valor !== '');

	// Se valida que no haya funciones con nombres vacios
	const functionsValidation = editableGramatica.ejecutaFuncion ? !editableGramatica.ejecutaFuncion.every((funcion) => funcion.nombreFuncion !== '') : false;

	// Se valida que la operacion entre condiciones sea congruente
	let operationValidation;
	if (editableGramatica.condiciones.length > 1) {
		operationValidation = editableGramatica.operacion.match(/\*/gi)
			? editableGramatica.operacion.match(/\*/gi).length !== editableGramatica.condiciones.length
			: true;
	} else {
		operationValidation = false;
	}

	// Se valida que no haya condiciones con parámetros vacíos
	const condicionalValidation =
		editableGramatica.condiciones.length === 0 ||
		(editableGramatica.condiciones &&
			!editableGramatica.condiciones.every(
				(condicion) => condicion.condicional !== '' && condicion.nombreIE !== '' && condicion.valor !== '' && condicion.variable !== ''
			));

	return (
		<div>
			<div className='form-actions' align='right'>
				<button disabled={flagFunctions} className='form-button secondary-button' onClick={() => history.push('/gramaticas')}>
					Cancelar
				</button>
				<button
					disabled={
						nodoDestinoValidation ||
						scriptValidation ||
						condicionalValidation ||
						operationValidation ||
						functionsValidation ||
						scriptEmptyValidation ||
						titleValidation
					}
					onClick={() => guardaGramatica({ nombre: title, arista: editableGramatica, _id: gramatica._id })}
					className='form-button primary-button'
				>
					Guardar
				</button>
			</div>

			{flagFunctions && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Se ha detectado un cambio en las funciones, es forzoso guardar la gramática *</span>
				</div>
			)}

			{titleValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Se debe especificar el titulo de la gramática *</span>
				</div>
			)}
			{nodoDestinoValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Se debe especificar el nodo destino *</span>
				</div>
			)}
			{scriptValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Debe existir al menos un script *</span>
				</div>
			)}
			{scriptEmptyValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Existen scripts que no se encuentran definidos *</span>
				</div>
			)}
			{operationValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* El numero de asteriscos no coincide con el número de condiciones *</span>
				</div>
			)}
			{condicionalValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Existen condiciones sin definir *</span>
				</div>
			)}
			{functionsValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Existen funciones sin nombre *</span>
				</div>
			)}
		</div>
	);
}

//#endregion
